"use client";

import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { GlassCard } from "@/src/components/GlassCard";
import { HOME_WHY_CHOOSE_ITEMS } from "../home.data";

// * ─── Why Choose Us ──────────────────────────────────────────────────────────
export function HomeWhyChooseUsSection() {
  const { t } = useTranslation("common");

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-walnut-900 dark:text-white mb-4">
            {t("whyChooseUs.title")}
          </h2>
          <p className="text-lg text-walnut-700 dark:text-walnut-300 max-w-2xl mx-auto">
            {t("whyChooseUs.subtitle")}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {HOME_WHY_CHOOSE_ITEMS.map((item, index) => (
            <GlassCard key={index} className="p-6">
              <div className="w-12 h-12 rounded-lg bg-walnut-100 dark:bg-walnut-800 flex items-center justify-center mb-4">
                <item.icon className="w-6 h-6 text-walnut-700 dark:text-walnut-300" />
              </div>
              <h3 className="text-xl font-semibold text-walnut-900 dark:text-white mb-3">
                {t(item.titleKey)}
              </h3>
              <p className="text-walnut-700 dark:text-walnut-300">
                {t(item.descriptionKey)}
              </p>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  );
}
